"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactHelmet = _interopRequireDefault(require("react-helmet"));
var _PageTitle = _interopRequireDefault(require("./PageTitle.style"));
var _excluded = ["title", "children", "description", "wrapTitle"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var PageTitle = function PageTitle(_ref) {
  var title = _ref.title,
    children = _ref.children,
    description = _ref.description,
    wrapTitle = _ref.wrapTitle,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_PageTitle["default"], _extends({
    wrapTitle: wrapTitle
  }, otherProps), /*#__PURE__*/_react["default"].createElement(_reactHelmet["default"], {
    key: title,
    title: title,
    meta: [{
      name: 'description',
      content: description
    }]
  }), children || title);
};
PageTitle.defaultProps = {
  title: '',
  children: null,
  description: null,
  wrapTitle: false,
  lightweight: false
};
PageTitle.propTypes = {
  /** The text of the page title */
  title: _propTypes["default"].string,
  /** The childred provided */
  children: _propTypes["default"].node,
  /** The meta description to summarizes the page's content. */
  description: _propTypes["default"].string,
  /** If false, the title will not wrap and will overflow with ellipsis */
  wrapTitle: _propTypes["default"].bool,
  lightweight: _propTypes["default"].bool
};
PageTitle.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "PageTitle",
  "props": {
    "title": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "The text of the page title",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "children": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "The childred provided",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "description": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "The meta description to summarizes the page's content.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "wrapTitle": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "If false, the title will not wrap and will overflow with ellipsis",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "lightweight": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    }
  }
};
var _default = /*#__PURE__*/(0, _react.memo)(PageTitle);
exports["default"] = _default;